// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.text--default[data-v-b1ffc372]{color:var(--block-text-color);white-space:normal}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
